import departureCity from '@/js/common/Domain/Hydrator/fromRouter/departureCity';
import checkInDateRange from '@/js/common/Domain/Hydrator/fromRouter/checkInDateRange';
import nightRange from '@/js/common/Domain/Hydrator/fromRouter/nightRange';
import touristGroup from '@/js/common/Domain/Hydrator/fromRouter/touristGroup';
import operators from '@/js/common/Domain/Hydrator/fromRouter/operators';
import meals from '@/js/common/Domain/Hydrator/fromRouter/meals';
import warranted from '@/js/common/Domain/Hydrator/fromRouter/warranted';
import isExclusive from '@/js/common/Domain/Hydrator/fromRouter/isExclusive';
import directFlights from '@/js/common/Domain/Hydrator/fromRouter/directFlights';
import block from '@/js/common/Domain/Hydrator/fromRouter/block';
import bonusMiles from '@/js/common/Domain/Hydrator/fromRouter/bonusMiles';
import mirCashback from '@/js/common/Domain/Hydrator/fromRouter/mirCashback';

import '@/js/common/plugins/jquery.unparam.min';

//не использовать считывание параметров priceFrom и priceTo из-за бага IN2-27
export default (urlParams) => {
    const urlQuery = window.location.search?.slice(1);
    const { identity, identities, hotelOfferIdentities } = $.unparam(urlQuery);
    if (typeof urlParams !== 'string') {
        const shortParams = {};
        if (identity) {
            shortParams.identities = [identity];
        }
        if (identities) {
            shortParams.identities = identities;
        }
        if (hotelOfferIdentities) {
            shortParams.hotelOfferIdentities = hotelOfferIdentities;
        }
        return shortParams;
    }
    const params = $.unparam(urlParams);
    const tourCriteria = {
        ...departureCity(params),
        ...checkInDateRange(params),
        ...nightRange(params),
        ...touristGroup(params),
        ...operators(params),
        ...meals(params),
        ...warranted(params),
        ...isExclusive(params),
        ...directFlights(params),
        ...block(params),
        ...bonusMiles(params),
        ...mirCashback(params),
    };

    let ages;
    if (params.ages) {
        ages = _.values(params.ages);
    }

    let element;
    let sid;
    element = params.sid;
    if (element) {
        sid = element;
    }

    let hsid;
    element = params.hsid;
    if (element) {
        hsid = element;
    }

    let productType;
    element = params.productType;
    if (element) {
        productType = element;
    }

    let operatorId;
    element = params.operatorId;
    if (element) {
        operatorId = element;
    }

    let minPrice;
    element = params.minPrice;
    if (element) {
        minPrice = element;
    }

    let oilTaxPrice;
    element = params.oilTaxPrice;
    if (element) {
        oilTaxPrice = element;
    }

    let hotelMinPriceIdentity;
    element = params.hotelMinPriceIdentity;
    if (element) {
        hotelMinPriceIdentity = element;
    }

    let hotelMinPrice;
    element = params.hotelMinPrice;
    if (element) {
        hotelMinPrice = element;
    }

    let hotelMinPriceOilTax;
    element = params.hotelMinPriceOilTax;
    if (element) {
        hotelMinPriceOilTax = element;
    }
    let groupSearch;
    if(params.groupSearch) {
        groupSearch = params.groupSearch;
    }
    let prepayments;
    if (params.prepayments) {
        prepayments = Object.values(params.prepayments).map((prepayment) => Number(prepayment));
    }

    return {
        tourCriteria,
        identity,
        identities: identities || [identity],
        hotelOfferIdentities,
        sid,
        hsid,
        ages,
        productType,
        operatorId,
        minPrice,
        oilTaxPrice,
        hotelMinPriceIdentity,
        groupSearch,
        hotelMinPrice,
        hotelMinPriceOilTax,
        directFlight: params.directFlight,
        searchSource: params.searchSource,
        block: params.block,
        selectedOperators: params.selectedOperators,
        prepayments,
        bonusMiles: params.bonusMiles,
        mirCashback: params.mirCashback,
    };
};